import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAnalyticsPieFill';
/** Renders an SVG icon. */
const SvgAnalyticsPieFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M14.5 30h1.031C21.865 30 27 24.865 27 18.531a.53.53 0 0 0-.531-.531H14.5a.5.5 0 0 1-.5-.5V5.531A.53.53 0 0 0 13.469 5C7.135 5 2 10.135 2 16.469V17.5C2 24.404 7.596 30 14.5 30"
      />
      <path
        fill="currentColor"
        d="M17 2.429V14a1 1 0 0 0 1 1h11.571c.79 0 1.429-.64 1.429-1.429C31 6.628 25.372 1 18.429 1 17.639 1 17 1.64 17 2.429"
      />
    </svg>
  );
};
SvgAnalyticsPieFill.displayName = displayName;
export default SvgAnalyticsPieFill;
